import React from "react";
import TickSimpleIcon from "./Icons/TickSimple";

import styled, { css } from "styled-components";
import { HtmlContent } from "./Content";

const TickListStyles = styled.ul`
  ${({ ...props }) => css`
    margin-top: 24px;
    li {
      display: flex;
      font-size: 1rem;
      margin-bottom: 8px;

      svg {
        margin-right: 16px;
        flex-shrink: 0;
        color: ${props.theme.colors.primary};
      }
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      margin-top: 32px;
      li {
        margin-bottom: 16px;
      }
    }
  `}
`;

export const TickList = ({ tickList }) => {
  return (
    tickList.length > 0 && (
      <TickListStyles>
        {tickList.map((tick, index) => {
          return (
            <li key={index}>
              <TickSimpleIcon />
              <span>
                <HtmlContent htmlString={tick.usp} />
              </span>
            </li>
          );
        })}
      </TickListStyles>
    )
  );
};
